import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import NumberFieldBase from 'common/Form/Fields/NumberFieldBase';

const valueTransformer = value => value;
const numberFormatProps = { allowLeadingZeros: true, inputMode: 'numeric', pattern: '[0-9]*' };

const SmsCodeField = ({ field, onBlur, onChange, onFocus }) => {
  const stableTransformer = useCallback(valueTransformer, []);

  return (
    <NumberFieldBase
      field={field}
      numberFormatProps={numberFormatProps}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      valueTransformer={stableTransformer}
    />
  );
};

SmsCodeField.propTypes = {
  field: PropTypes.object.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

export default SmsCodeField;
